var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4844 21.1719H23.5156V23.5156H16.4844V21.1719Z",
    fill: "#CECABE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4515 23.5156H25.8594V24.6874C25.8594 25.335 25.3351 25.8593 24.6875 25.8593H15.3125C14.6649 25.8593 14.1406 25.335 14.1406 24.6874V23.5156H7.54852C6.03333 23.5156 4.6933 22.5497 4.21356 21.1123L0 8.46948V34.0624C0 36.0009 1.57715 37.5781 3.51562 37.5781H36.4844C38.4229 37.5781 40 36.0009 40 34.0624V8.4704L35.7861 21.1123C35.3067 22.5497 33.9667 23.5156 32.4515 23.5156Z",
    fill: "#CECABE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 2.42188H15.3125C13.374 2.42188 11.7969 3.99902 11.7969 5.9375V7.10938H2.0163L6.43616 20.3708C6.59637 20.8502 7.04376 21.1719 7.54852 21.1719H14.1406V20C14.1406 19.3524 14.6649 18.8281 15.3125 18.8281H24.6875C25.3351 18.8281 25.8594 19.3524 25.8594 20V21.1719H32.4515C32.9562 21.1719 33.4036 20.8502 33.5638 20.3708L37.984 7.10938H28.2031V5.9375C28.2031 3.99902 26.626 2.42188 24.6875 2.42188ZM14.1406 7.10938V5.9375C14.1406 5.29083 14.6658 4.76562 15.3125 4.76562H24.6875C25.3342 4.76562 25.8594 5.29083 25.8594 5.9375V7.10938H14.1406Z",
    fill: "#CECABE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW1);
export default __webpack_public_path__ + "static/media/w1.b38b5d0bdf6fc2b53448f4c4b0caca45.svg";
export { ForwardRef as ReactComponent };